import { handleResponse } from '../../helpers/authservice/user.service'

export const state = {
    todos: [],
};

export const getters = {
    todos: state => state.todos,
};

export const mutations = {
    setTodos(state, newValue) {
        state.todos = newValue
    },
};

export const actions = {
    fethgetReferenceCode({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/referencia/filters`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethregisterQuote({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/quote`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethgetallResistenciasMecanicas({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/resistenciasmecanicas`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethgetallQuote({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/quote/list`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethgetallTipoanillo({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/tipoanillo`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethgetallTipoherraje({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/tipoherraje`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethgetQuoteAnality({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/quote/anality`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethregisterClient({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/users/client`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fetchQuotebyId({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/quote/${payload.id}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethallClient({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/users/client`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethallCentroCostos({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/centroCostos`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethallClasesActivida({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/claseactividad`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethallClients({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/users/client`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethallMaterials({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/material`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethallPuestoTrabajo({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/puestotrabajo`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethallReferencia({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/referencia`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethcategoriesAll({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/categories`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    addCategories({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/categories`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    updateCategories({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/categories`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethupdatematerials({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/material/${payload.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fetchCreateUser({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/users`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fetchuserList({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/users`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethListproduct({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethListimages({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products/productimages`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'apikey': process.env.VUE_APP_APIKEY,
                    'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethusaveImport({ commit }, payload) {
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products/import`, {
                method: 'POST',
                headers: {
                    'apikey': process.env.VUE_APP_APIKEY,
                    'token': payload.token,
                },
                body: payload.data
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    fethudeleteFiles({ commit }, payload) {
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products/deleteFiles`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'apikey': process.env.VUE_APP_APIKEY,
                    'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    fethusaveCoverFiles({ commit }, payload) {
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products/addFiles/${payload.tipo}`, {
                method: 'POST',
                headers: {
                    'apikey': process.env.VUE_APP_APIKEY,
                    'token': payload.token,
                },
                body: payload.data
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    fethusaveFiles({ commit }, payload) {
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products/addFiles`, {
                method: 'POST',
                headers: {
                    'apikey': process.env.VUE_APP_APIKEY,
                    'token': payload.token,
                },
                body: payload.data
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    fethusaveProducto({ commit }, payload) {
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products`, {
                method: 'POST',
                headers: {
                    'apikey': process.env.VUE_APP_APIKEY,
                    'token': payload.token,
                },
                body: payload.data
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    fethdeleteProducto({ commit }, payload) {
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products/${payload.id}`, {
                method: 'DELETE',
                headers: {
                    'apikey': process.env.VUE_APP_APIKEY,
                    'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    fethdeleteSelectProductos({ commit }, payload) {
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products/deleteids`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'apikey': process.env.VUE_APP_APIKEY,
                    'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    fethupdateProducto({ commit }, payload) {
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products/${payload.id}`, {
                method: 'PUT',
                headers: {
                    'apikey': process.env.VUE_APP_APIKEY,
                    'token': payload.token,
                },
                body: payload.data
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    fethvariables({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/variables`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethupdatevariables({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/variables/${payload.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
                body: JSON.stringify(payload.data)
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fetchProductbyId({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/products/${payload.id}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },
    fethClientsbyId({commit}, payload){
        return new Promise((resolve, reject) => {
            fetch(process.env.VUE_APP_API + `/api/client/${payload.id}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                'apikey': process.env.VUE_APP_APIKEY,
                'token': payload.token,
                },
            })
            .then(handleResponse)
            .then(res => {
                resolve(res);
            });
        })
    },


};
